
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerNoApiParameter } from "@ucs/Store/CustomHandlerCreator";

type CustomHandlerType = ApiHandlerNoApiParameter<{ gridHeight: number }, {}>;

export const DispatchPLPRendering: CustomHandlerType = ({ dispatch, parameter: { gridHeight } }) => {
    dispatch({
        type: "Custom/SetPLPRender",
        gridHeight,
    });
};

export const chain = [DispatchPLPRendering];

const setPLPRendering = createHandlerChainRunner(chain, "SetPLPRendering");
export default setPLPRendering;
